<template>
  <v-dialog
    v-model="dialog"
    max-width="680px"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Header / Toolbar estilo Inspección -->
      <v-toolbar color="secondary" dark flat class="table-header-toolbar px-2 px-sm-4">
        <div class="d-flex align-center header-main-info flex-grow-1 min-width-0">
          <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
            <v-icon color="white">mdi-comment-text-multiple-outline</v-icon>
          </div>
          <div class="header-text-block min-width-0 mr-2 mr-sm-3">
            <div class="header-company-title font-weight-bold text-truncate">
              Comentarios del Reporte
            </div>
          </div>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="header-count-chip font-weight-bold elevation-1 flex-shrink-0"
          >
            <v-icon left size="14" color="secondary">mdi-comment-outline</v-icon>
            {{ Comentarios ? Comentarios.length : 0 }} Obs.
          </v-chip>
        </div>

        <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
          <v-btn icon dark @click="cerrarDialogo" class="btn-circle-tooltip">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-toolbar>

      <!-- Contenido del Modal -->
      <v-card-text
        class="pa-3 pa-sm-4 pa-md-5"
        style="max-height: 72vh; overflow-y: auto"
      >
        <!-- Formulario para Nuevo Comentario (Solo si no es solo lectura o APROBADO) -->
        <div v-if="!esSoloLectura" class="mb-4">
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2"
              >mdi-comment-plus-outline</v-icon
            >
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Agregar Observación o Recomendación
            </span>
          </div>

          <v-form ref="form" v-model="valid" @submit.prevent="enviar">
            <v-textarea
              v-model="Item.comentario"
              label="Escribir comentario u observación *"
              placeholder="Escriba aquí los detalles, hallazgos o recomendaciones para este reporte..."
              rows="3"
              auto-grow
              outlined
              dense
              prepend-inner-icon="mdi-pencil-outline"
              class="rounded-lg"
              hide-details="auto"
              :rules="[
                (v) => !!(v && v.trim()) || 'El comentario es requerido',
              ]"
            ></v-textarea>

            <div class="d-flex justify-end mt-3">
              <v-btn
                color="primary"
                elevation="2"
                class="btn-form-action text-capitalize px-5 rounded-lg font-weight-bold"
                :disabled="
                  !valid || !Item.comentario || !Item.comentario.trim()
                "
                :loading="sending"
                @click="enviar()"
              >
                <v-icon left small>mdi-send</v-icon>
                Enviar Comentario
              </v-btn>
            </div>
          </v-form>
        </div>

        <!-- Historial de Observaciones -->
        <div class="section-title d-flex align-center mb-3 mt-2">
          <v-icon color="secondary" small class="mr-2">mdi-history</v-icon>
          <span class="text-subtitle-2 font-weight-bold text--primary">
            Historial de Observaciones
          </span>
        </div>

        <div v-if="Comentarios && Comentarios.length > 0" class="comments-feed">
          <v-card
            v-for="(item, index) in Comentarios"
            :key="index"
            outlined
            class="mb-3 rounded-lg border-light comment-item elevation-0"
          >
            <div class="pa-3 bg-light">
              <div class="d-flex align-center justify-space-between mb-2">
                <div class="d-flex align-center">
                  <v-avatar color="primary lighten-4" size="32" class="mr-2">
                    <v-icon color="primary" small>mdi-account</v-icon>
                  </v-avatar>
                  <div>
                    <div class="text-caption font-weight-bold primary--text">
                      {{ item.nombre_autor || item.name || "Usuario" }}
                    </div>
                  </div>
                </div>
                <div class="text-caption text--secondary d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-clock-outline</v-icon
                  >
                  {{ formatearFechaHora(item.created_at) }}
                </div>
              </div>

              <div class="comment-text body-2 text--primary pl-10 pr-2">
                {{ item.comentario }}
              </div>
            </div>
          </v-card>
        </div>

        <!-- Estado vacío sin comentarios -->
        <div
          v-else
          class="d-flex flex-column align-center justify-center py-8 text-center text--secondary"
        >
          <v-icon size="48" color="grey lighten-1" class="mb-2"
            >mdi-comment-outline</v-icon
          >
          <span class="body-2"
            >No se han registrado observaciones en este reporte aún.</span
          >
        </div>
      </v-card-text>

      <!-- Footer / Acciones -->
      <v-card-actions class="form-card-actions pa-3 pa-sm-4 bg-light border-top d-flex justify-end">
        <v-btn
          outlined
          color="grey darken-1"
          class="btn-form-action text-capitalize px-4 rounded-lg font-weight-medium"
          @click="cerrarDialogo()"
        >
          <v-icon left small>mdi-close</v-icon>
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";
import global from "@/global";

export default {
  props: ["dialog", "Item", "soloLectura"],
  data() {
    return {
      valid: false,
      sending: false,
    };
  },
  computed: {
    ...mapState("reporteconsolidado", ["Comentarios"]),
    esSoloLectura() {
      if (this.soloLectura) return true;
      if (
        this.Item &&
        (this.Item.estado === "APROBADO" ||
          this.Item.estado_reporte === "APROBADO")
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions("reporteconsolidado", ["cargarComentarios"]),

    async enviar() {
      if (!this.$refs.form || !this.$refs.form.validate()) return;
      if (!this.Item.comentario || !this.Item.comentario.trim()) return;

      try {
        this.sending = true;
        const url = "comentarios/store";
        let datos = {
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
          comentario: this.Item,
        };
        const response = await axios.post(url, datos);
        this.$alertify.success("Comentario agregado correctamente");

        if (response.data) {
          const reportesActualizados =
            response.data.datos ||
            (response.data.verificarestadoreporte &&
              response.data.verificarestadoreporte.success &&
              response.data.verificarestadoreporte.success.datos);
          if (reportesActualizados) {
            this.$store.commit(
              "reporteconsolidado/DatosReporte",
              reportesActualizados,
            );
          }
        }

        if (this.Item && this.Item.adm_rep_id) {
          await this.cargarComentarios({ id_reportes: this.Item.adm_rep_id });
        }

        this.Item.comentario = "";
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      } catch (error) {
        console.error("error!", error);
        this.$alertify.error("Ocurrió un error al guardar el comentario");
      } finally {
        this.sending = false;
      }
    },

    cerrarDialogo() {
      this.$emit("dialog", false);
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },

    formatearFechaHora(fechaStr) {
      return global.formatearFechaHora(fechaStr);
    },
  },
};
</script>

<style scoped>
.min-width-0 {
  min-width: 0;
}

.table-header-toolbar {
  min-height: 58px;
}

.header-main-info {
  overflow: hidden;
}

.header-icon-box {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-company-title {
  font-size: 1.08rem;
  letter-spacing: -0.2px;
}

.header-count-chip {
  font-size: 0.85rem;
  height: 28px;
}

.section-title {
  border-left: 3px solid #424242;
  padding-left: 8px;
  margin-bottom: 12px;
}

.bg-light {
  background-color: #f8fafc !important;
}

.border-top {
  border-top: 1px solid #e2e8f0 !important;
}

.border-light {
  border: 1px solid #e2e8f0 !important;
}

.comment-text {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
}

.comments-feed {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 30px;
    height: 30px;
    min-width: 30px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.85rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.7rem !important;
    height: 22px !important;
    padding: 0 5px !important;
  }

  .header-count-chip .v-icon {
    font-size: 12px !important;
    margin-right: 2px !important;
  }

  .form-card-actions {
    flex-direction: column-reverse !important;
    align-items: stretch !important;
    gap: 8px !important;
    padding: 12px 14px !important;
  }

  .form-card-actions ::v-deep .v-btn,
  .form-card-actions .btn-form-action,
  .btn-form-action {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    margin: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .form-card-actions ::v-deep .v-btn + .v-btn {
    margin-left: 0 !important;
  }
}
</style>
